import { render, staticRenderFns } from "./recordDetails.vue?vue&type=template&id=fb656fc8&scoped=true"
import script from "./recordDetails.vue?vue&type=script&lang=js"
export * from "./recordDetails.vue?vue&type=script&lang=js"
import style0 from "./recordDetails.vue?vue&type=style&index=0&id=fb656fc8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb656fc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb656fc8')) {
      api.createRecord('fb656fc8', component.options)
    } else {
      api.reload('fb656fc8', component.options)
    }
    module.hot.accept("./recordDetails.vue?vue&type=template&id=fb656fc8&scoped=true", function () {
      api.rerender('fb656fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shoppingGift/createRecord/recordDetails.vue"
export default component.exports